/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 捷克语
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">為了通知您預購商品到店，並在取貨時驗證您的預購，我們將收集您的<strong>姓名與電子郵件</strong>地址，並將其轉移至新加坡進行處理，以便向您發送取貨碼。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">我們將僅在交付產品給您，以及確保遵循稅務稽核與反洗錢等法律要求所必需的期間內，保存您的個人資料。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">這些處理您個人資料活動的法律依據，是<strong>與當事人有契約或類似契約之關係，且已採取適當之安全措施</strong>。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        您得如何對您的個人資料行使權利（例如查詢、請求補充或更正、和/或請求刪除），可透過我們的隱私支援平台<br>(<a href="https://privacy.mi.com/support/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff"> https://privacy.mi.com/support/</span></a>) 。
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">小米的隱私政策請參閱：<br><a href="https://privacy.mi.com/all/languages/" style="text-decoration:none"><span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span></a>。</span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)